/**
 * Enterprise Sessions Page
 * NEVCO logo + "VIDEO PRO TRAINING" + 3 nav buttons + BACK
 */

import { navigate } from '../router';

export function renderSessions(container: HTMLElement): void {
  container.innerHTML = `
    <div class="enterprise-page">
      <a href="https://www.nevco.com" target="_blank" rel="noopener noreferrer">
        <img src="/assets/enterprise/nevco-logo.png" alt="NEVCO Logo" class="landing-logo" />
      </a>
      <h2>VIDEO PRO TRAINING</h2>
      <button class="ent-btn" id="ent-nav-lessons">VIEW LESSONS</button>
      <button class="ent-btn" id="ent-nav-videos">VIEW TRAINING VIDEOS</button>
      <button class="ent-btn" id="ent-back-landing">BACK</button>
    </div>
  `;

  container.querySelector('#ent-nav-videos')!
    .addEventListener('click', () => navigate('/videos'));
  container.querySelector('#ent-nav-lessons')!
    .addEventListener('click', () => navigate('/lessons'));
  container.querySelector('#ent-back-landing')!
    .addEventListener('click', () => navigate('/'));
}
